<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.company.company') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('administration.company.company'), href: '/companies' },
          { text: $t('administration.company.edit'), active: true }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-4 col-md-5">
        <ts-card>
          <ts-card-wrapper>
            <div class="row form-group m-b-15">
              <div class="col-md-12">
                <div id="img-frame" class="text-center">
                  <label for="logo_file" id="label_logo_file">
                    <img :src="logo_file_src" alt="" />
                  </label>
                  <input
                    type="file"
                    id="logo_file"
                    ref="logo_file"
                    accept="image/*"
                    @change="onFileSelected"
                  />
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-6">
                <label
                  >{{ $t('administration.company.code')
                  }}<span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  v-model="model.company_code"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('company_code') }"
                />
                <div class="invalid-feedback" v-if="errors.has('company_code')">
                  {{ errors.first('company_code') }}
                </div>
              </div>
              <div class="col-md-6">
                <label
                  >{{ $t('administration.company.prefix') }}
                  <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  v-model="model.prefix"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('prefix') }"
                />
                <div class="invalid-feedback" v-if="errors.has('prefix')">
                  {{ errors.first('prefix') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-12">
                <label
                  >{{ $t('administration.company.name_en') }}
                  <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  v-model="model.company_name_en"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('company_name_en') }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('company_name_en')"
                >
                  {{ errors.first('company_name_en') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-6">
                <ts-checkbox v-model="model.enable_stock_receive_confirmation"
                  >Stock Receive Confirmation</ts-checkbox
                >
              </div>
              <div class="col-md-6">
                <ts-checkbox v-model="model.allow_duplicate_fee_type"
                  >Allow duplicate fee type</ts-checkbox
                >
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-sm-12 col-lg-8 col-md-7">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.company.name_kh')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.company_name_kh"
                      class="form-control kh-font"
                      :class="{ 'is-invalid': errors.has('company_name_kh') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('company_name_kh')"
                    >
                      {{ errors.first('company_name_kh') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.company.fax_number')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.fax_number"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('fax_number') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('fax_number')"
                    >
                      {{ errors.first('fax_number') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.company.phone')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.phone"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('phone') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('phone')">
                      {{ errors.first('phone') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.company.email')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="email"
                      v-model="model.email"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('email') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('email')">
                      {{ errors.first('email') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-form-label control-label">{{
                    $t('administration.company.facebook_page')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.facebook"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('facebook') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('facebook')">
                      {{ errors.first('facebook') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.company.web_site')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.website"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('website') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('website')">
                      {{ errors.first('website') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.company.zip_code')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.zip_code"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('zip_code') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('zip_code')">
                      {{ errors.first('zip_code') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.company.city_name')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.company_city"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('company_city') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('company_city')"
                    >
                      {{ errors.first('company_city') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.company.address')
                  }}</label>
                  <div class="col-md-12">
                    <textarea
                      v-model="model.address"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('address') }"
                      rows="5"
                    ></textarea>
                    <div class="invalid-feedback" v-if="errors.has('address')">
                      {{ errors.first('address') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-12 col-lg-12 col-md-12 text-right">
                <ts-button
                  color="primary"
                  :waiting="waiting"
                  @click.prevent="update"
                >
                  {{ $t('administration.company.update') }}
                </ts-button>
                <ts-button
                  class="ml-2"
                  @click.prevent="$router.push({ name: 'company' })"
                  >{{ $t('administration.company.cancel') }}</ts-button
                >
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'company-edit',
  data () {
    return {
      model: {
        company_id: 0,
        company_code: '',
        company_name_kh: '',
        company_name_en: '',
        phone: '',
        email: '',
        website: '',
        address: '',
        facebook: '',
        prefix: '',
        zip_code: '',
        company_city: '',
        fax_number: '',
        enable_stock_receive_confirmation: false,
        allow_duplicate_fee_type: false
      },
      errors: new Errors(),
      waiting: false,
      file: '',
      logo_file_src:
        'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'
    }
  },
  created () {
    this.setEditData()
  },
  computed: {
    ...mapState('company', ['edit_data'])
  },
  methods: {
    onFileSelected () {
      const file = this.$refs.logo_file.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          this.logo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        } else {
          this.logo_file_src =
            'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'

          this.$toasted.error('invalid file type!')
          this.$refs.logo_file.value = ''
        }
      }
    },

    uploadfile () {
      this.file = this.$refs.logo_file.files[0]
        ? this.$refs.logo_file.files[0]
        : null
      if (this.file) {
        let formData = new FormData()
        formData.append('logo', this.file)
        return this.$store.dispatch('company/uploadLogo', formData)
      }

      return this.edit_data.image_logo
    },

    async update () {
      this.errors = new Errors()
      this.waiting = true
      let file_upload_path = await this.uploadfile()
      this.$store
        .dispatch(
          'company/update',
          Object.assign({}, this.model, { image_logo: file_upload_path })
        )
        .then(response => {
          this.clearFormInput()
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'company' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    clearFormInput () {
      this.model.company_id = ''
      this.model.company_code = ''
      this.model.company_name_kh = ''
      this.model.company_name_en = ''
      this.model.phone = ''
      this.model.email = ''
      this.model.website = ''
      this.model.address = ''
      this.model.facebook = ''
      this.model.zip_code = ''
      this.model.company_city = ''
      this.model.fax_number = ''
      this.model.enable_stock_receive_confirmation = false
      this.model.allow_duplicate_fee_type = false
      this.$refs.logo_file.value = ''
      this.logo_file_src =
        'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'
    },
    setEditData () {
      this.model.company_id = this.edit_data.company_id
      this.model.company_code = this.edit_data.company_code
      this.model.company_name_kh = this.edit_data.company_name_kh
      this.model.company_name_en = this.edit_data.company_name_en
      this.model.phone = this.edit_data.phone
      this.model.email = this.edit_data.email
      this.model.website = this.edit_data.website
      this.model.address = this.edit_data.address
      this.model.facebook = this.edit_data.facebook_page
      this.model.prefix = this.edit_data.prefix
      this.model.zip_code = this.edit_data.zip_code
      this.model.company_city = this.edit_data.company_city
      this.model.fax_number = this.edit_data.fax_number
      this.model.enable_stock_receive_confirmation = this.edit_data.enable_stock_receive_confirmation
      this.model.allow_duplicate_fee_type = this.edit_data.allow_duplicate_fee_type
      this.logo_file_src = this.edit_data.image_logo
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('company/RESET_STATE')
      this.$store.commit('company/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>

<style scoped>
#logo_file {
  display: none;
}
#img-frame img {
  object-fit: contain;
  width: 208px;
  height: 201px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, .1); */
  border-radius: 10px;
  padding: 5px;
}
#label_logo_file {
  cursor: pointer;
}
</style>
